module.exports = __webpack_public_path__ + "static/media/leukocytes-top.d2f4ee95.png";